
import { module } from 'stereomodularjs';
import gsap from 'gsap';
import { createApp } from "vue"
import SearchComponent from '@/js/components/programmation/Search.vue';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        const togglePlugin = {
            name: 'togglePlugin',
            install(app) {
                app.config.globalProperties.$toggle = function(args) {
                    let cls = args.class ?? "is-active";
                    let target = args.target ?? 'body';
                    let ariaHiddenToggle = args.ariaHiddenToggle ?? null;
                    let focus = args.focus ?? null;
                    let focusDelay = args.focusDelay ?? null;

                    if (args.ariaHiddenToggle) {
                        let ariaHiddenElm = document.querySelector(ariaHiddenToggle);
                        if (ariaHiddenElm.getAttribute('aria-hidden') == "false") {
                            ariaHiddenElm.setAttribute('aria-hidden', 'true')
                        } else {
                            ariaHiddenElm.setAttribute('aria-hidden', 'false')
                        }
                    }

                    let elmTargets = document.querySelectorAll(target);
                    elmTargets.forEach(targetEl => {
                        targetEl.classList.toggle(cls);
                    });

                    if (focus && document.querySelector(focus)) {
                        if (focusDelay) {
                            setTimeout(() => {
                                document.querySelector(focus).focus();
                            }, focusDelay);
                        } else {
                            document.querySelector(focus).focus();
                        }
                    }
                }
            }
        }

        const followCursor = {
            mounted: (el) => {
                const cursor = el.querySelector('.js-cursor');

                if (!cursor) return;

                // Centrer le curseur (évite le décalage au chargement)
                gsap.set(cursor, { xPercent: -50, yPercent: -50 });
                gsap.set(cursor, { x: cursor.offsetWidth / 2, y: cursor.offsetHeight / 2 });

                let xTo = gsap.quickTo(cursor, "x", { duration: 0.45, ease: "power3" });
                let yTo = gsap.quickTo(cursor, "y", { duration: 0.45, ease: "power3" });

                let lastMouseX = null;
                let lastMouseY = null;

                const updateCursorPosition = (x, y) => {
                    const rect = el.getBoundingClientRect();
                    const cursor_rect = cursor.getBoundingClientRect();

                    let newX = Math.min(
                        Math.max(x - rect.left, cursor_rect.width / 2),
                        rect.width - cursor_rect.width / 2
                    );

                    let newY = Math.min(
                        Math.max(y - rect.top, cursor_rect.height / 2),
                        rect.height - cursor_rect.height / 2
                    );

                    xTo(newX);
                    yTo(newY);
                };

                el.addEventListener("mousemove", e => {
                    lastMouseX = e.clientX;
                    lastMouseY = e.clientY;
                    updateCursorPosition(lastMouseX, lastMouseY);
                });

                el.addEventListener("mouseleave", () => {
                    lastMouseX = null;
                    lastMouseY = null;
                    updateCursorPosition(0, 0);
                });
            }
        }

        const dates = this.el.getAttribute('data-dates');
        const cat = parseInt(this.el.getAttribute('data-cat')) ?? null;
        const app = createApp({
            template: '<SearchComponent :dates="dates" :cat="cat" />',
            components: {
                SearchComponent
            },
            data() {
                return {
                    dates: JSON.parse(dates),
                    cat: cat
                }
            },
			methods: {
				refreshDates(force = false) {
					const ONE_HOUR = 60 * 60 * 1000;
					try {
						const last = parseInt(localStorage.getItem('programmation_last_refresh') || '0', 10);
						const isStale = Date.now() - last > ONE_HOUR;
                        console.log(isStale, force);
						if (!isStale && !force) return;
					} catch (e) {
						// ignore storage errors
                        console.error("Programmation: error getting last refresh: ", e);
					}

                    console.log('fetching dates');
					fetch(`${WPURLS.ajaxurl}?action=dates`, {
						method: 'GET',
						credentials: 'same-origin',
						headers: { 'Accept': 'application/json' }
					})
						.then(r => r.json())
						.then(data => {
							if (data && data.dates) {
								this.dates = data;
							}
                            console.log('dates fetched');
							try {
								localStorage.setItem('programmation_last_refresh', Date.now().toString());
							} catch (e) {}
						})
						.catch(() => {
							// silently fail
						});
				}
			},
			mounted() {
				// Initial check on mount
				this.refreshDates(false);

				// Refresh when tab becomes visible and data is stale
				this._onVis = () => this.refreshDates(false);
				document.addEventListener('visibilitychange', this._onVis);

				// Periodic stale check (every 5 minutes)
				this._refreshTimer = setInterval(() => this.refreshDates(false), 5 * 60 * 1000);
			},
			beforeUnmount() {
				if (this._refreshTimer) clearInterval(this._refreshTimer);
				document.removeEventListener('visibilitychange', this._onVis);
			},
        })
        app.use(togglePlugin);
        app.directive('followCursor', followCursor);
        app.mount(this.el);
    }
}
